/* globals zc $  _ app utils analytics */

(function (window) {
  'use strict'

  zc.views.DashboardView = zc.views.PageView.extend({
    initialize: function (options) {
      zc.views.PageView.prototype.initialize.call(this, options)
      var couponCode = this.model.get('couponCode')
      var self = this
      this.socket = app.socket
      this.billingModel = new zc.models.Billing()
      if (couponCode) {
        this.model.set('couponApplicationStatus', 'ready')
        this.billingModel.readCoupon(couponCode)
          .success(function (coupon) {
            if (!coupon.valid) {
              return false // no-oop for invalid coupons
            }
            self.billingModel.set({coupon: coupon})
            self.render()
          })
      }

      this.listenTo(this.model.projectGroup.projects, 'remove', this.renderLocalStorageInfo)
      this.listenTo(app.cloudDrive, 'cloudDrive:change', this.renderCloudDriveInfo)
      this.listenTo(this.billingModel, 'change:coupon', this.render)
      this.listenTo(this.model, 'change:couponApplicationStatus', this.render)
      this.billingModel.on('loading', function () {
        self.model.set('couponApplicationStatus', 'loading')
      })
    },

    template: _.template($('.dashboard-template').html()),

    className: 'dashboard page',

    events: {
      'change .wav-recording': 'wavRecordingInputChange',
      'change .host-voip': 'hostVoipInputChange',
      'change .soundboard-enabled': 'soundboardEnabledInputChange',
      'click .create-project': 'renderProjectCreateModal',
      'click .apply-coupon': 'applyCoupon',
      'click .close-coupon': 'closeCoupon'
    },

    wavRecordingInputChange: function (e) {
      app.user.settings.set({wavRecording: !!e.target.checked})
    },

    hostVoipInputChange: function (e) {
      app.user.settings.set({hostVoip: !!e.target.checked})
    },

    soundboardEnabledInputChange: function (e) {
      app.user.settings.set({soundboard: !!e.target.checked})
    },

    createProject: function (attrs) {
      attrs.owner = app.user.get('username')
      attrs.ownerId = app.user.id
      attrs.cloudDrive = app.user.has('cloudToken') ? app.user.get('cloudToken').provider : null

      return new Promise(function (resolve, reject) {
        app.socket.emit('projects:create', attrs, function (err, attrs) {
          if (err) {
            utils.notify('error', err)
            reject(err)
            return
          }

          var project = new zc.models.Project(attrs)

          analytics.track('Created Project', {
            projectName: project.get('name'),
            projectId: project.id
          })

          project.recorder.recording.set({
            projectId: project.id,
            ownerId: app.user.id
          })
          project.recorder.createRecording(function (err) {
            if (err) {
              console.log(err)
              utils.notify('error', err)
              reject(err)
            } else {
              window.location.href = '/' + app.user.get('username') + '/' + project.get('slug')
            }
          })
        })
      })
    },

    renderProjectCreateModal: function () {
      var modalView = new zc.views.ModalView({
        addClass: 'project-create-modal',
        model: this.model,
        ChildView: zc.views.ProjectCreateFormView,
        callback: this.createProject
      })

      modalView.render()
    },

    allowCreateProject: function () {
      this.$createProject.removeClass('disabled')
    },

    renderProjects: function () {
      var projectGroupView = new zc.views.ProjectGroupView({
        model: this.model.projectGroup,
        collection: this.model.projectGroup.projects,
        el: this.$projects
      })
      projectGroupView.render()

      this.model.projectGroup.fetchProjects()
    },

    renderLocalStorageInfo: function () {
      var localStorageInfoView = new zc.views.LocalStorageInfoView({model: app.localStorageManager, el: this.$localStorageInfo})
      localStorageInfoView.render()
      app.localStorageManager.queryStorageQuota()
    },

    renderCloudDriveInfo: function () {
      if (!this.cloudDriveInfoView) {
        this.cloudDriveInfoView = new zc.views.CloudDriveInfoView({model: app.cloudDrive, el: this.$cloudDriveInfo})
      }
      this.cloudDriveInfoView.render()
    },

    renderPlanUsage: function () {
      this.planUsageView = new zc.views.PlanUsageView({model: app.user, el: this.$planUsage})
      this.planUsageView.render()
    },

    /**
     * used to check if the trial period for this account has ended
     * @return {[type]} [description]
     */
    checkSubscription: function () {
      new zc.views.CheckSubscriptionView({}).render()
    },

    applyCoupon: function (e) {
      e.preventDefault()
      e.stopPropagation()
      var self = this
      var coupon = this.billingModel.get('coupon')
      try {
        this.billingModel
          .applyCouponCode(coupon.id, app.user.id)
          .success(function (customer) {
            if (customer && customer.discount && customer.discount.coupon.id === coupon.id) {
              self.model.set('couponApplicationStatus', 'success')
            }
          })
          .error(function (e) {
            self.model.set('couponApplicationStatus', 'error')
            console.log(e)
          })
      } catch (e) {
        analytics.track('Coupon Error', {
          message: e.message
        })
        console.log('Coupon Apply Error', e)
      }
    },

    closeCoupon: function (e) {
      e.preventDefault()
      e.stopPropagation()
      this.billingModel.set('coupon', false)
      this.model.set('couponCode', false)
      this.model.set('couponApplicationStatus', false)
    },

    render: function () {
      var attrs = Object.assign({}, {coupon: this.billingModel.get('coupon')}, this.model.attrs())
      this.$el.html(this.template(attrs))
      this.$projects = this.$('.projects')
      this.$cloudDriveInfo = this.$('.cloud-drive-info')
      this.$localStorageInfo = this.$('.local-storage-info')
      this.$planUsage = this.$('.plan-usage')
      this.$createProject = this.$('.create-project')

      this.renderProjects()
      this.renderPlanUsage()

      this.checkSubscription()

      this.renderCloudDriveInfo()

      this.renderLocalStorageInfo()

      return this
    }
  })
})(window)
